module.exports = __webpack_public_path__ + "img/qys-ac2.0339156f.jpg";